import { render } from "./SponsorManageListPage.vue?vue&type=template&id=7d9d5297&lang=true"
import script from "./SponsorManageListPage.vue?vue&type=script&lang=js"
export * from "./SponsorManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__